var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.9999C15.1614 12.9999 17.7243 10.5375 17.7243 7.49993C17.7243 4.4624 15.1614 2 11.9999 2C8.83832 2 6.27539 4.4624 6.27539 7.49993C6.27539 10.5375 8.83832 12.9999 11.9999 12.9999Z",
    stroke: "url(#paint0_linear_1283_27507)",
    strokeWidth: 2.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7245 15.2002H18.1275C18.9645 15.2004 19.7726 15.4943 20.4 16.0266C21.0274 16.5589 21.4309 17.293 21.5347 18.091L21.9823 21.5273C22.0226 21.8369 21.9939 22.1511 21.8981 22.4492C21.8023 22.7473 21.6416 23.0224 21.4266 23.2563C21.2117 23.4901 20.9475 23.6774 20.6515 23.8056C20.3554 23.9339 20.0344 24.0001 19.7097 24.0001H4.29029C3.96557 24.0001 3.64456 23.9339 3.34855 23.8056C3.05254 23.6774 2.7883 23.4901 2.57338 23.2563C2.35845 23.0224 2.19775 22.7473 2.10194 22.4492C2.00613 22.1511 1.97741 21.8369 2.01767 21.5273L2.46418 18.091C2.56802 17.2926 2.97184 16.5582 3.59972 16.0259C4.2276 15.4935 5.03627 15.1999 5.87367 15.2002H6.27553",
    stroke: "url(#paint1_linear_1283_27507)",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1283_27507",
    x1: 6.61886,
    y1: 2.51333,
    x2: 16.4713,
    y2: 12.8442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335083,
    stopColor: "#E6745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678481,
    stopColor: "#A6708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8490A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1283_27507",
    x1: 2.6,
    y1: 15.6109,
    x2: 8.38842,
    y2: 28.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335083,
    stopColor: "#E6745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678481,
    stopColor: "#A6708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8490A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.428a547736a0fc243a85440cb581bedf.svg";
export { ForwardRef as ReactComponent };